import { Messages } from '~src/codegen/Localize';
import { ContentTypeFilterClause,ExplorableItemDefinition } from '~src/contentDefinitionInterfaces/ContentDefinitionsTypes';
import { GenericCard } from '~src/spacesPlatform/components/card/GenericCard';
import { CustomViewsContentType } from '~src/spacesPlatform/models/ContentTypes';
import { ServerFilterClauses } from '~src/ts/helpers/ServerFilterClauses';
import { CustomViews } from '~src/ts/ServerApi/CustomViews/CustomViews';

import { getGenericDefaultFilters } from '../../../contentDefinitions/getDefaultFilters';

export const CustomViewDefinition: ExplorableItemDefinition = {
  itemType: 'customView',
  pluralName: Messages.customViews,
  singularName: Messages.customView,
  emptyStateMessage: Messages.workbooksCustomViewsEmptyMessage,
  contentFilterKeys: CustomViewsContentType.filterKeys,
  defaultFilters: getGenericDefaultFilters,
  cardComponent: GenericCard,
  listViewIconUrl: null,
  filterClause: ServerFilterClauses.ContentType(['customView']) as ContentTypeFilterClause,
  getBasicQuery: () => {
    return CustomViews.all().withExtraParams(CustomViewsContentType.extraQueryParams);
  },
  getContentInfo: () => {
  },
  supportedDisplayModes: ['list'],
};
